import { Global } from '@emotion/react'
import { baseStyles } from 'styles/base'

const GlobalStyles = () => <Global styles={baseStyles} />

export default GlobalStyles
